// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import theme from '../../../styled-components/dark';
import { KLKnifeIcon } from '../assets/img';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Knifes = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const LabelWrapper = styled.div`
  font-weight: bold;
  line-height: 1em;
`;

const RawLabel = styled.span`
  text-transform: uppercase;
`;

const NbKnifesLabel = styled.span`
  color: ${theme.KLCounter.color};
`;

const KnifeIcon = styled.img`
  width: 1.1em;
  background-repeat: no-repeat;
  object-fit: cover;
  object-position: center;
  margin: 0.3em;

  &:first-child,
  &:last-child {
    margin: 0;
  }

  &:last-child {
    margin-right: 0.75em;
  }

  transition: filter 200ms ease-in-out;

  ${({ $isRemaining }) => css`
    filter: brightness(${$isRemaining ? '100%' : '55%'});
  `}
`;

type KLKnifeCounterProps = {
  remainingKnifes?: number;
};

const KLKnifeCounter = ({ remainingKnifes = 0 }: KLKnifeCounterProps) => {
  const Icons = useMemo(() => {
    let remKnifes = remainingKnifes;
    const Knifes = [];

    for (let i = 0; i < 3; i++) {
      Knifes.push(
        <KnifeIcon
          key={`knife-icon-${i}`}
          src={KLKnifeIcon}
          alt="Couteau en jeu restant"
          $isRemaining={remKnifes-- > 0}
        />,
      );
    }

    return () => Knifes;
  }, [remainingKnifes]);
  return (
    <Wrapper>
      <Knifes>
        <Icons />
      </Knifes>
      {remainingKnifes ? (
        <LabelWrapper>
          <RawLabel>Il reste </RawLabel>
          <NbKnifesLabel>{remainingKnifes}</NbKnifesLabel>
          <br />
          <RawLabel>{remainingKnifes > 1 ? ` poignards` : ' poignard'} en jeu</RawLabel>
        </LabelWrapper>
      ) : (
        <LabelWrapper>
          <RawLabel>Il ne reste plus de poignard en jeu</RawLabel>
        </LabelWrapper>
      )}
    </Wrapper>
  );
};

export default KLKnifeCounter;
